export default {"src":"/_next/static/media/HeaderMenIcon1.85148ef3.svg","height":72,"width":71,"blurWidth":0,"blurHeight":0};